import React from 'react'
import PropTypes from 'prop-types';

import {extractIndividualErrors} from 'validation'
import BaseComponent from 'common/BaseComponent'
import Tooltip from 'common/Tooltip'
import ErrorTooltip from 'common/ErrorTooltip'
import theme from 'theme/theme.scss';

export default class TextArea extends BaseComponent {

    render() {
        const errorMessages = extractIndividualErrors(this.props.errorMessages, this.props.name, this.props.index);
        return (
            <div>
                <label htmlFor={this.props.id}>{this.props.label}{this.props.required ? <span>*</span> : ""}
                    {this.props.tooltip ? <Tooltip for={this.props.id} value={this.props.tooltip}/> : ""}
                </label>
                <textarea id={this.props.id} value={this.props.value} onChange={this.props.onChange} maxLength={this.props.max}
                    className={errorMessages.length > 0 ? theme.errorField : ""} disabled={this.props.disabled}/>
                {errorMessages.length > 0 ? <ErrorTooltip for={this.props.id} value={errorMessages}/> : ""}
            </div>
        )
    }
}

TextArea.propTypes = {
    id: PropTypes.string.isRequired,
    value: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number
    ]).isRequired,
    label: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
    max: PropTypes.number,
    required: PropTypes.bool,
    tooltip: PropTypes.string,
    disabled: PropTypes.bool
};


// WEBPACK FOOTER //
// ./src/common/TextArea/index.js